import { DocsInfoTooltip } from "components/Tooltip/DocsInfoTooltip";

/** Docs page for dashboards (Engine docs, content-management/dashboards.mdx). */
export const DASHBOARD_DOCS_URL_PATH = "/docs/dashboards";

/**
 * "?" help icon linking to the Dashboards documentation page. Shown in the
 * dashboard view header; the dashboard edit and create screens reach the same
 * page through the record header (docsUrlPath / recordDocLinks).
 */
export const DashboardDocsLink = () => (
    <DocsInfoTooltip
        title="Dashboards"
        text="How to configure widgets, filters and fullscreen mode."
        urlPath={DASHBOARD_DOCS_URL_PATH}
    />
);
